import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccd3ffbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-password-password" }
const _hoisted_2 = {
  key: 0,
  "data-test": "desc_msg1"
}
const _hoisted_3 = { "data-test": "desc_msg2" }
const _hoisted_4 = {
  key: 1,
  "data-test": "desc_msg3"
}

import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordDesc',
  props: {
  // 表示種別
  type: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

log.trace('PasswordDesc setup start.')

// プロパティ定義


log.trace('PasswordDesc setup end.')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (props.type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('body.common.passowrd.desc.header.message1')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('body.common.passowrd.desc.header.message2')), 1),
      (props.type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('body.common.passowrd.desc.header.message3')), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(BaseAccordion, {
      accordionId: "entryPass",
      headerId: "entryPassHeader",
      bodyId: "entryPassbody",
      headerTitle: _ctx.$t('body.common.passowrd.desc.content.title')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.8')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.2')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.3')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.4')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.5')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.6')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.password.4.body.7')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"])
  ], 64))
}
}

})